import { useCallback } from 'react'

import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

/**
 * Hook to track user menu item clicks with Segment analytics.
 * Captures the current screen name, menu item clicked, and navigation details.
 *
 * @returns A callback function to be passed to UserMenu's onMenuItemClick prop
 */
export function useMenuItemAnalytics() {
  const { trackButtonClicked } = useAnalytics()

  const handleMenuItemClick = useCallback(
    (itemKey: string, href: string) => {
      trackButtonClicked({
        buttonName: `user_menu_${itemKey.replace(/-/g, '_')}`,
        cta_url: href,
        url: document.URL,
        referrer: document.referrer,
      })
    },
    [trackButtonClicked]
  )

  return handleMenuItemClick
}
